module.exports = __webpack_public_path__ + "media/customizations/lakenona/logo-55372c0873117ec741ad7ebc2a51544a.png";